<template>
  <el-container style="height:100%">

    <div class="mark-body">
      <div>
        <h2>训练批改</h2>
        <el-divider></el-divider>
      </div>
      <div class="mark-middle">
        <div class="mark-search">
          <el-input placeholder="搜索" v-model.trim="searchValue" @input="searchName">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
        <div class="mark-classify">
          <el-select v-model="classifyValue" placeholder="请选择" @change="selectClassify">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>

      </div>
      <div class="mark-table">
        <el-table ref="singleTable" :data="showTable" style="width: 100%;border: 1px solid #ebeef5;" :header-cell-style="{background:'#f5f5f5',color:'#555'}">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column property="student_name" label="活动名称" width="300">
            <template slot-scope="scope">
              {{scope.row.paper_title}}
            </template>
          </el-table-column>
          <el-table-column property="submit_time" label="待批改/全部" width="198">
            <template slot-scope="scope">
              {{scope.row.stay_read}}/{{scope.row.total_num}}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="200">
            <template slot-scope="scope" v-if="scope.row.total_num">{{scope.row.stay_read?'待批阅':'已批阅'}}</template>
          </el-table-column>
          <el-table-column label="操作" width="190">
            <template slot-scope="scope" v-if="scope.row.total_num">
              <el-button type="text" v-if="scope.row.stay_read===0" @click="readPaper(scope.row.id)">查看</el-button>
              <el-button type="text" v-else-if="scope.row.stay_read!==0" style="color: red;" @click="readPaper(scope.row.id)">批阅</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20,50,100,200]"
          :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="totalSize" :hide-on-single-page="true"></el-pagination>
      </div>
    </div>
  </el-container>
</template>

<script>
import {
  specialTrainingMarkList,
  teacherPublishedResultsData,
  teacherRemindTestData
} from "@/api/show";
import { isArray } from 'util';
import Common from '@/utils/common';
export default {
  data() {
    return {
      classroom_id: "",//专题id
      competitionId: "",//训练id
      classifyValue: "",
      searchValue: "", //搜索内容
      searchData: "", //搜索结果
      tableData: [], //分页前的数据
      pagesize: 20, //设置每页显示条目个数为20
      totalSize: "", //总个数
      currentPage: 1, //设置当前页默认为1
      options: [
        { value: "", label: "全部" },
        { value: 1, label: "已批阅" },
        { value: 2, label: "待批阅" }
      ],
      replay_type: 2,
    };
  },
  props: ['courseSet'],
  created() {
    if (Object.keys(this.$route.params).length > 0) {
      if (this.courseSet) {
        this.competitionId = this.courseSet.parentId;
      } else {
        this.competitionId = this.$route.params.competitionId;
      }
      this.classroom_id = this.$route.params.classroomId;
      sessionStorage.setItem('competitionId', this.competitionId)
      sessionStorage.setItem('classroomId', this.classroom_id)
    } else {
      this.competitionId = sessionStorage.getItem('competitionId')
      this.classroom_id = sessionStorage.getItem('classroomId')
    }
  },
  mounted() {
    sessionStorage.removeItem('info')
    this.initData();
  },
  computed: {

    //showTable计算属性通过slice方法计算表格当前应显示的数据
    showTable() {
      if (isArray(this.searchData)) {
        this.currentPage = 1;
        this.totalSize = this.searchData.length;
        return this.searchData.slice(
          (this.currentPage - 1) * this.pagesize,
          this.currentPage * this.pagesize
        );
      } else {
        this.totalSize = this.tableData.length;
        return this.tableData.slice(
          (this.currentPage - 1) * this.pagesize,
          this.currentPage * this.pagesize
        );
      }
    }
  },
  methods: {
    //数据初始化
    initData: function () {
      let params = {
        classroom_id: this.classroom_id,
        competition_id: this.competitionId,
        replay_type: this.replay_type
      };
      specialTrainingMarkList(params).then(response => {
        this.tableData = response.data;
      });
    },

    //搜索名字
    searchName: function () {

      if (!this.searchValue) {
        this.searchData = "";
        return true;
      }
      if (!this.tableData.length) {
        return true;
      }
      this.searchData = [];
      for (let index = 0; index < this.tableData.length; index++) {
        let name = this.tableData[index].paper_title;
        if (name.includes(this.searchValue)) {
          this.searchData.push(this.tableData[index]);
        }
      }
    },
    //切换学生状态
    selectClassify: function () {
      if (!this.classifyValue) {
        this.searchData = "";
        return true;
      }
      if (!this.tableData.length) {
        return true;
      }
      this.searchData = [];
      for (let index = 0; index < this.tableData.length; index++) {
        let stay_read = this.tableData[index].stay_read;
        let isExamines = this.tableData[index].is_examines;
        if (this.classifyValue === 1) {
          if (stay_read === 0) {
            this.searchData.push(this.tableData[index]);
          }
        } else if (this.classifyValue === 2) {
          if (stay_read !== 0) {
            this.searchData.push(this.tableData[index]);
          }
        }
      }
    },
    //查看成绩
    readResult: function (id) {
      this.$router.push({
        name: "train-view-result",
        params: {
          classroomId: this.classroom_id,
          competitionId: this.competitionId,
          paperId: id,
          replay_type: this.replay_type
        }
      });
    },
    //老师批阅试卷,id为活动id
    readPaper: function (id) {
      this.$router.push({
        name: "train-correct-paper",
        params: {
          classroomId: this.classroom_id,
          competitionId: this.competitionId,
          paperId: id,
          replay_type: this.replay_type,
        }
      });
    },

    closeWin: function () {
      window.close();
    },
    //切换分页
    handleCurrentChange: function (page) {
      this.currentPage = page;
    },
    handleSizeChange: function (val) {
      this.pagesize = val;
    },
    timestampToTime: function (val) {
      if (val) {
        return Common.timestampToTime(val);
      }
    }
  },
  filters: {


  }
};
</script>

<style scoped>
/*批卷列表页面*/
.divide-vertical {
  display: block;
}
.mark-body {
  width: 940px;
  /* height: 100%; */
  margin: auto;
}
.mark-body .mark-header {
  display: flex;
  height: 100px;
  border-radius: 3px;
  box-sizing: border-box;
  border: 1px solid #dce1e6;
}
.mark-body .mark-header .mark-header-left {
  line-height: 25px;
  padding: 10px 15px;
  box-sizing: border-box;
}
.mark-body .mark-header .mark-header-left .paper-title {
  padding-left: 5px;
}
.mark-body .mark-header .mark-header-left span {
  margin: 0 5px;
}
.mark-body .mark-header .mark-header-right {
  padding: 20px;
  line-height: 45px;
  width: 300px;
  text-align: right;
  box-sizing: border-box;
}
.mark-body .mark-header .mark-header-right span {
  font-size: 30px;
  color: red;
  font-weight: bold;
}
.mark-body .mark-middle {
  margin: 20px 0;
  /*display: flex;*/
}
.mark-body .mark-middle .mark-search {
  position: relative;
  display: inline-block;
  margin-right: 30px;
}

.mark-body .mark-middle .mark-classify {
  display: inline-block;
}
.mark-body .mark-middle .announces-result {
  display: inline-block;
}
.mark-body
  .mark-table
  .el-table
  .el-table__body-wrapper
  .el-table__body
  .el-table__row
  button {
  padding: 0;
}
.mark-body .mark-table .first-sort {
  padding: 0px 5px;
  background-color: #ed4300;
  color: #ffffff;
}
.mark-body .mark-table .second-sort {
  padding: 0px 5px;
  background-color: #ff7316;
  color: #ffffff;
}
.mark-body .mark-table .third-sort {
  padding: 0px 5px;
  background-color: #f59a23;
  color: #ffffff;
}
.current-header {
  background-color: #dce1e6;
}
.mark-body .el-pagination {
  margin: 20px 0;
}
/*批卷列表页面*/
</style>